import { repo } from "remult";
import * as entities from "./entities";

export const associationRepo = repo(entities.Association);
export const associationTeamRepo = repo(entities.AssociationTeam);
export const futureNotificationRepo = repo(entities.FutureNotification);
export const groupRepo = repo(entities.Group);
export const groupOpportunityRepo = repo(entities.GroupOpportunity);
export const groupAssociationRepo = repo(entities.GroupAssociation);
export const imageRepo = repo(entities.Image);
export const otpRepo = repo(entities.OTP);
export const opportunityRepo = repo(entities.Opportunity);
export const opportunityParticipantRepo = repo(entities.OpportunityParticipant);
export const opportunityReportRepo = repo(entities.OpportunityReport);
export const opportunitySkillRepo = repo(entities.OpportunitySkill);
export const organizationRepo = repo(entities.Organization);
export const organizationManagerRepo = repo(entities.OrganizationManager);
export const repeatedOpportunityRepo = repo(entities.RepeatedOpportunity);
export const skillRepo = repo(entities.Skill);
export const statusRepo = repo(entities.Status);
export const subTeamRepo = repo(entities.SubTeam);
export const teamRepo = repo(entities.Team);
export const teamManagerRepo = repo(entities.TeamManager);
export const teamOpportunityRepo = repo(entities.TeamOpportunity);
export const timeReportRepo = repo(entities.TimeReport);
export const userRepo = repo(entities.User);
export const userSkillRepo = repo(entities.UserSkill);
export const userVehicleRepo = repo(entities.UserVehicle);
export const vehicleRepo = repo(entities.Vehicle);
export const communicationRecordRepo = repo(entities.CommunicationRecord);
export const communityRepo = repo(entities.Community);
export const communityAssociationRepo = repo(entities.CommunityAssociation);
export const missionRepo = repo(entities.Mission);
export const categoryRepo = repo(entities.Category);
export const populationRepo = repo(entities.Population);
export const subCategoryRepo = repo(entities.SubCategory);
export const subCategoryFieldConfigRepo = repo(entities.SubCategoryFieldConfig);
export const teamFieldConfigRepo = repo(entities.TeamFieldConfig);
export const dateAndTimeRangeRepo = repo(entities.DateAndTimeRange);
export const goldenNotificationRepo = repo(entities.GoldenNotification);
export const aidRequestFormRepo = repo(entities.AidRequestForm);
export const userAvailabilityRepo = repo(entities.UserAvailability);
export const opportunityAvailabilityRepo = repo(
  entities.OpportunityAvailability,
);
export const userNotificationRepo = repo(entities.UserNotification);
export const organizationManagerNotificationRepo = repo(
  entities.OrganizationManagerNotification,
);
export const associationPositionRepo = repo(entities.AssociationPosition);
export const positionRepo = repo(entities.Position);
export const landingPageConfigRepo = repo(entities.LandingPageConfig);
export const partnerOrganizationRepo = repo(entities.PartnerOrganization);
export const partnerOrganizationAddressRepo = repo(
  entities.PartnerOrganizationAddress,
);
export const partnerOrganizationManagerRepo = repo(
  entities.PartnerOrganizationManager,
);
export const partnerOrganizationLeadRepo = repo(
  entities.PartnerOrganizationLead,
);
export const volunteerOrganizationLeadRepo = repo(
  entities.VolunteerOrganizationLead,
);
export const volunteerOrganizationRepo = repo(entities.VolunteerOrganization);
export const volunteerOrganizationContactRepo = repo(
  entities.VolunteerOrganizationContact,
);
export const volunteerOrgActivityDomainRepo = repo(
  entities.VolunteerOrgActivityDomain,
);
export const volunteerOrgActivityRepo = repo(entities.VolunteerOrgActivity);
export const volunteerOrgProjectRepo = repo(entities.VolunteerOrgProject);
export const volunteerOrgProjectAssignmentRepo = repo(
  entities.VolunteerOrgProjectAssignment,
);
export const callCenterAlertRepo = repo(entities.CallCenterAlert);
export const callCenterChatMessageRepo = repo(entities.CallCenterChatMessage);
export const callCenterFaqItemRepo = repo(entities.CallCenterFaqItem);
export const callCenterTourStepRepo = repo(entities.CallCenterTourStep);
export const callCenterOrgSettingsRepo = repo(entities.CallCenterOrgSettings);
export const callCenterShiftRepo = repo(entities.CallCenterShift);
export const callCenterShiftTaskRepo = repo(entities.CallCenterShiftTask);
export const callCenterVolunteerRepo = repo(entities.CallCenterVolunteer);
export const callCenterVolunteerGroupRepo = repo(
  entities.CallCenterVolunteerGroup,
);